var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createVerticalSearchResponse } from '../transformers/searchservice/createVerticalSearchResponse';
import { defaultApiVersion } from '../constants';
import { QuerySource } from '../models/searchservice/request/QuerySource';
import { createUniversalSearchResponse } from '../transformers/searchservice/createUniversalSearchResponse';
import { serializeStaticFilters } from '../serializers/serializeStaticFilters';
import { serializeFacets } from '../serializers/serializeFacets';
import { getClientSdk } from '../utils/getClientSdk';
/**
 * The implementation of SearchService which hits LiveAPI.
 *
 * @internal
 */
var SearchServiceImpl = /** @class */ (function () {
    function SearchServiceImpl(config, httpService, apiResponseValidator) {
        this.config = config;
        this.httpService = httpService;
        this.apiResponseValidator = apiResponseValidator;
        this.universalSearchEndpoint = config.endpoints.universalSearch;
        this.verticalSearchEndpoint = config.endpoints.verticalSearch;
    }
    SearchServiceImpl.prototype.universalSearch = function (request) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response, _d, validationResult;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParams = __assign(__assign(__assign({ input: request.query, experienceKey: this.config.experienceKey }, ('apiKey' in this.config && { api_key: this.config.apiKey })), { v: defaultApiVersion, version: this.config.experienceVersion, limit: JSON.stringify(request.limit), location: this.stringifyLatLong(request.location), locale: this.config.locale, skipSpellCheck: request.skipSpellCheck, session_id: request.sessionId, sessionTrackingEnabled: request.sessionTrackingEnabled, queryTrigger: request.queryTrigger, context: JSON.stringify(request.context), referrerPageUrl: request.referrerPageUrl, source: request.querySource || QuerySource.Standard, visitorId: (_a = this.config.visitor) === null || _a === void 0 ? void 0 : _a.id, visitorIdMethod: (_b = this.config.visitor) === null || _b === void 0 ? void 0 : _b.idMethod, restrictVerticals: request.restrictVerticals && request.restrictVerticals.join(',') }), (_c = this.config) === null || _c === void 0 ? void 0 : _c.additionalQueryParams);
                        if (!('token' in this.config)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.httpService.get(this.universalSearchEndpoint, queryParams, getClientSdk(request.additionalHttpHeaders), this.config.token)];
                    case 1:
                        _d = _e.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.httpService.get(this.universalSearchEndpoint, queryParams, getClientSdk(request.additionalHttpHeaders))];
                    case 3:
                        _d = _e.sent();
                        _e.label = 4;
                    case 4:
                        response = _d;
                        validationResult = this.apiResponseValidator.validate(response);
                        if (validationResult instanceof Error) {
                            return [2 /*return*/, Promise.reject(validationResult)];
                        }
                        return [2 /*return*/, createUniversalSearchResponse(response)];
                }
            });
        });
    };
    SearchServiceImpl.prototype.verticalSearch = function (request) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response, _e, validationResult;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        queryParams = __assign(__assign(__assign({ experienceKey: this.config.experienceKey }, ('apiKey' in this.config && { api_key: this.config.apiKey })), { v: defaultApiVersion, version: this.config.experienceVersion, locale: this.config.locale, input: request.query, location: this.stringifyLatLong(request.location), verticalKey: request.verticalKey, filters: request.staticFilters && serializeStaticFilters(request.staticFilters), limit: request.limit, offset: request.offset, retrieveFacets: request.retrieveFacets, facetFilters: request.facets && serializeFacets(request.facets), skipSpellCheck: request.skipSpellCheck, queryTrigger: request.queryTrigger, session_id: request.sessionId, sessionTrackingEnabled: request.sessionTrackingEnabled, sortBys: JSON.stringify(request.sortBys || []), context: JSON.stringify(request.context), referrerPageUrl: request.referrerPageUrl, source: request.querySource || QuerySource.Standard, locationRadius: (_a = request.locationRadius) === null || _a === void 0 ? void 0 : _a.toString(), queryId: request.queryId, visitorId: (_b = this.config.visitor) === null || _b === void 0 ? void 0 : _b.id, visitorIdMethod: (_c = this.config.visitor) === null || _c === void 0 ? void 0 : _c.idMethod }), (_d = this.config) === null || _d === void 0 ? void 0 : _d.additionalQueryParams);
                        if (!('token' in this.config)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.httpService.get(this.verticalSearchEndpoint, queryParams, getClientSdk(request.additionalHttpHeaders), this.config.token)];
                    case 1:
                        _e = _f.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.httpService.get(this.verticalSearchEndpoint, queryParams, getClientSdk(request.additionalHttpHeaders))];
                    case 3:
                        _e = _f.sent();
                        _f.label = 4;
                    case 4:
                        response = _e;
                        validationResult = this.apiResponseValidator.validate(response);
                        if (validationResult instanceof Error) {
                            return [2 /*return*/, Promise.reject(validationResult)];
                        }
                        return [2 /*return*/, createVerticalSearchResponse(response)];
                }
            });
        });
    };
    /**
     * Converts a {@link LatLong} into the format the Answers API expects.
     */
    SearchServiceImpl.prototype.stringifyLatLong = function (latLong) {
        if (!latLong) {
            return undefined;
        }
        return "".concat(latLong.latitude, ",").concat(latLong.longitude);
    };
    return SearchServiceImpl;
}());
export { SearchServiceImpl };
//# sourceMappingURL=SearchServiceImpl.js.map